// Resolves once the image is downloaded and decoded, so it paints at full size the moment
// it is mounted. Never rejects: a broken image still has to replace its loading state.
export default function preloadImage(url) {
  const image = new Image()
  image.src = url

  return image.decode().catch(() => {})
}
